
import { useCallback, useEffect, useState } from 'react';
import { GridPaginationModel } from '@mui/x-data-grid-pro';
import { SetPreferenceSignature } from 'hooks/preferences';
import { IDashboardSettings } from 'components/preferences';

type GridPaginationModelChangeHandler = (params: GridPaginationModel) => void;
type UsePersistedPageSizeResultProps = {
    settings: IDashboardSettings | null,
    setSettings: SetPreferenceSignature
};
type UsePersistedPageSizeResult = [
    GridPaginationModel | undefined,
    GridPaginationModelChangeHandler
];

const usePersistedPageSize: (props: UsePersistedPageSizeResultProps) => UsePersistedPageSizeResult = (props: UsePersistedPageSizeResultProps) => {
    const { settings, setSettings } = props;
    const [ pagination, setPagination ] = useState<GridPaginationModel>();
    const [ _lastPagination, _setLastPagination ] = useState<GridPaginationModel>({page: 1, pageSize: 101});

    const persistPagination = (newPagination: GridPaginationModel) => {
        if (settings) {
            setSettings({
                ...settings,
                pageSize: newPagination.pageSize
            });
        }
    }
    
    useEffect(() => {
        if (settings) {
            setPagination({pageSize: settings.pageSize, page: 0 } as GridPaginationModel);
        }
    }, [ settings ]);

    const handlePaginationChange: GridPaginationModelChangeHandler = useCallback(
        (state: GridPaginationModel) => {
            if (pagination?.page !== state.page || pagination?.pageSize !== state.pageSize) {
                setPagination(state);
            }

            if (_lastPagination.pageSize !== state.pageSize) {
                _setLastPagination({pageSize: state.pageSize, page: state.page} as GridPaginationModel);
            } else {
                return;
            }

            if (settings === null) return;
            if (pagination === undefined) return;
            
            if (settings.pageSize === pagination.pageSize && pagination.pageSize != state.pageSize) {
                console.log(`${pagination.pageSize} => ${state.pageSize}`);
                persistPagination({pageSize: state.pageSize, page: state.page} as GridPaginationModel);                
            }
        },
        [ settings, pagination, _lastPagination ]
    );

    return [
        pagination,
        handlePaginationChange
    ]
};

export default usePersistedPageSize;